<template>
  <div style="width: 100%">
    <div class="searchcontent">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入政策措施名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model.trim="searchForm.policyclassid" placeholder="请选择政策措施类别">
            <el-option v-for="item in searchForm.policyclasslist" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model.trim="searchForm.policytype" placeholder="请选择政策措施类型">
            <el-option v-for="item in searchForm.policytypelist" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model.trim="searchForm.pm_p4" placeholder="请选择出台单位级别">
            <el-option v-for="item in searchForm.pm_p4list" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
                    <el-select size="small" v-model.trim="searchForm.pm_p5" placeholder="请选择是否可量化" >
                        <el-option
                        v-for="item in searchForm.pm_p5list"
                        :key="item.systemCodeID"
                        :label="item.systemCodeName"
                        :value="item.systemCodeID">
                        </el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item>
          <el-select size="small" v-model.trim="searchForm.logout_reason_id" placeholder="请选择注销原因">
            <el-option v-for="item in searchForm.logoutReasonList" :key="item.systemCodeID" :label="item.systemCodeName" :value="item.systemCodeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item placeholder="注销开始日期">
          <el-date-picker size="small" format="yyyy-MM-dd" v-model="searchForm.start_create_time" value-format="yyyy-MM-dd" type="date" placeholder="请选择注销开始日期" :picker-options="pickerOptions0"></el-date-picker>
        </el-form-item>
        <el-form-item placeholder="注销结束日期">
          <el-date-picker size="small" format="yyyy-MM-dd" v-model="searchForm.end_create_time" value-format="yyyy-MM-dd" type="date" placeholder="请选择注销结束日期" :picker-options="pickerOptions1"></el-date-picker>
        </el-form-item>
        <el-form-item placeholder="颁布开始日期">
          <el-date-picker size="small" format="yyyy-MM-dd" v-model="searchForm.start_logout_time" value-format="yyyy-MM-dd" type="date" placeholder="请选择颁布开始日期" :picker-options="pickerOptions2"></el-date-picker>
        </el-form-item>
        <el-form-item placeholder="颁布结束日期">
          <el-date-picker size="small" format="yyyy-MM-dd" v-model="searchForm.end_logout_time" value-format="yyyy-MM-dd" type="date" placeholder="请选择颁布结束日期" :picker-options="pickerOptions3"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <!-- v-if="permission.isHaveAddPermission" -->
          <el-button size="small" plain type="primary" v-if="permission.isHavePolicyAddPermission" icon="el-icon-plus" @click="editNotic('',1)">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 列表 -->
    <div class="searchtable">
      <el-table ref="table" :data="noticelist" border stripe v-loading="showDataLoading" :header-row-style="{height:'30px'}" :header-cell-style="{padding:'5px'}" :row-style="{height:'30px'}" :cell-style="{padding:'5px'}" :height="tableHeight">
        <el-table-column prop="" label="编号" width="60">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column prop="pmP1" label="政策措施名称" min-width="180">
          <template slot-scope="scope">
            <span @click="getDetail(scope.row)">
              <el-link type="primary">{{scope.row.pmP1}}</el-link>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="policyClassName" label="政策措施类别" width="160">
        </el-table-column>
        <el-table-column prop="policyTypeName" label="政策措施类型" width="220">
        </el-table-column>
        <el-table-column prop="pmP5Name" label="是否可资金量化" width="130">

        </el-table-column>
        <el-table-column prop="pmP6" min-width="130" label="标准/量化金额">

        </el-table-column>
        <el-table-column prop="pmP7" label="是否注销" width="130">
          <template slot-scope="scope">
            <span v-if="scope.row.pmP7 == 1">是</span>
            <span v-if="scope.row.pmP7 == 0">否</span>

          </template>
          <!-- (1:可以 2 ：不可以 3：可量化但无标准) -->
        </el-table-column>
        <el-table-column prop="logoutReason" width="180" label="注销原因">

        </el-table-column>

        <el-table-column prop="pmP10" width="180" label="注销日期">

        </el-table-column>
      </el-table>

      <div class="pageblock">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>

    </div>
    <!-- 维护资金量化标准-->
    <el-dialog title="政策详情" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :visible.sync="dialogdetailVisible" class="eldialog" v-loading="showDataFundLoading" :modal-append-to-body="true" append-to-body :style="'margin-top:0px;left:' + initLeft()">
      <div class="searchcontent descriptionsheight">
        <el-descriptions :model="policyContent" :column="1" :size="size" border>
          <el-descriptions-item>
            <template slot="label">
              政策措施名称：
            </template>
            {{policyContent.pmP1}}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="eldescriptionstop" :model="policyContent" :column="3" :size="size" border>
          <template slot="extra">
          </template>
          <!-- <el-descriptions-item>
                    <template slot="label"  >
                       政策措施名称：
                    </template>
                    {{policyContent.pmP1}}
                    </el-descriptions-item> -->
          <el-descriptions-item>
            <template slot="label">
              出台单位级别：
            </template>
            {{policyContent.regionLevelName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              政策措施类别：
            </template>
            {{policyContent.policyClassName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              是否可资金量化：
            </template>
            {{policyContent.systemCodeName}}

          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              标准/量化金额：
            </template>
            {{policyContent.pmP6}}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="eldescriptionstop" :model="policyContent" :column="1" :size="size" border>
          <el-descriptions-item>
            <template slot="label">
              政策措施内容摘要：
            </template>
            {{policyContent.pmP3}}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="eldescriptionstop" :model="policyContent" :column="1" :size="size" border>
          <el-descriptions-item>
            <template slot="label">
              政策须知：
            </template>
            <span v-html="policyContent.pmP11"></span>

            <!-- {{policyContent.pmP11}} -->
          </el-descriptions-item>
        </el-descriptions>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { queryPolicymeasureModel } from '@/request/aboutage.js'
import { systemcodeModule } from "@/request/systemmange.js";
import { permissionTool } from '@/tools/permissiontool.js'
import { policycompilationModule } from '@/request/policycompilation.js'
import $ from 'jquery'
import store from '@/store'
import { sysframe } from '@/tools/sysframe.js'
import { publicFun } from "@/tools/time.js";
import { rsa } from '@/tools/encrypt.js'
import baseUrl from "@/request/base.js";
import { baseconfig, rsaBasicModuleConfig, rsaMainModuleConfig } from '@/config.js'

export default {

  data() {
    var isPriceVlidator = (rule, value, callback) => {
      var pattern = /^\d+.?\d{0,2}$/;
      if (value.toString().indexOf(".") > 0) {
        if (value.toString().split(".")[1].length == 0) {
          return callback(new Error('内容小数点后补充完整'))
        } else {
          if (pattern.test(value)) {
            callback()
          } else {
            return callback(new Error('内容小数点后最多只能输入两位'))
          }
        }
      } else {
        if (value.length > 1) {
          if (value.toString().split(0, 1) == 0) {
            return callback(new Error('请重新输入内容,输入格式不正确'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
    return {

      pickerOptions0: {
        disabledDate: time => {
          let endDateVal = this.searchForm.end_create_time;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptions1: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.start_create_time;
          if (beginDateVal) {
            return (
              time.getTime() < new Date(beginDateVal).getTime()
            );
          }
        },
      },
      pickerOptions2: {
        disabledDate: time => {
          let endDateVal = this.searchForm.emd_logout_time;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptions3: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.start_logout_time;
          if (beginDateVal) {
            return (
              time.getTime() < new Date(beginDateVal).getTime()
            );
          }
        },
      },
      tableHeight: 400,
      size: '',
      disabled: false,
      loading: false,
      operKey: 0,
      sourceType: 1,
      noticelist: [],
      lsp: [],
      permission: {
        isHavePolicyAddPermission: false,
        isHavePolicyEditPermission: false,
        isHavePolicyLogoutPermission: false,
        // this.permission.isHavePolicyDeletePermission
        isHaveLookFundsAddPermission: false,
        isHaveFundsAddPermission: false,
        isHaveFundsEditPermission: false,
        isHaveFundsDeletePermission: false,
        isHaveFundsLogoutPermission: false,
        isHaveDeletePermission: false,
      },
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      showDataLoading: false,
      showDataFundLoading: true,
      addOrganizationLoading: false,
      addOrganizationisabled: false,
      dialogTitle: '',
      dialogType: 0,
      dialogFormVisible: false,
      dialogdetailVisible: false,
      dialogQuantitativeFormVisible: false,
      dialogLogoutStatueQuantitativeFormVisible: false,
      dialogQuantitativeTitle: '',
      dialogQuantitativeType: 0,
      noticedetail: '',
      adminRegionLevel: 0,
      detailSeeType: 0,
      //搜索
      searchForm: {
        keywords: '',
        policytype: '',
        policyclasslist: [
          {
            systemCodeID: -1,
            systemCodeName: '全部'
          }
        ],
        policyclassid: '',
        policytypelist: [
          {
            systemCodeID: -1,
            systemCodeName: '全部'
          }
        ],
        pmp4: '',
        pm_p4: '',
        pm_p4list: [
          {
            systemCodeID: -1,
            systemCodeName: '全部'
          }
        ],
        pm_p5: '',
        pm_p5list: [
          {
            systemCodeID: -1,
            systemCodeName: '全部'
          }
        ],
        logout_reason_id: '',
        logoutReasonList: [
          {
            systemCodeID: -1,
            systemCodeName: '全部'
          }
        ],
        pm_p10: '',
        start_create_time: '',
        end_create_time: '',
        start_logout_time: '',
        end_logout_time: '',

      },
      //添加
      addKey: 1,
      dialogVisible: false,


      // page:1,
      // pagesize:10,
      fundsstandardinfolist: [],
      policyContent: {},
      isStandardlogout: false,
      //修改
      show: false,

    }
  },
  created: async function () {
    //   await this.getpolicycompilation(1,10,-1,-1,"",-1,0,0)
    await this.getSystemcodeinfogetlist(2)
    this.getSystemcodeinfogetlist(3)
    this.getSystemcodeinfogetlist(6)
    this.getSystemcodeinfogetlist(4)
    this.getSystemcodeinfogetlist(7)
    // table的高
    //this.tableHeight=$(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true)
    this.tableHeight = ($(".tab-content").height() - 30 - $(".searchcontent").outerHeight(true) - $(".pageblock").outerHeight(true))
  },
    deactivated:function(){
        this.dialogdetailVisible = false;
    },


  methods: {
    initLeft() {
      return sysframe.getSideBarLeft()
    },
    //时间戳
    gettimestamp() {
      return new Date().getTime();
    },
    //获取
    async getSystemcodeinfogetlist(mark) {
      await systemcodeModule
        .systemcodeinfogetlist(mark)
        .then((response) => {
          switch (response.data.code) {
            case 100: {
              let obj = {
                systemCodeID: -1,
                systemCodeName: '全部'
              }
              if (mark == 2) {
                response.data.result.forEach(e => {

                  const str = {
                    systemCodeID: e.systemCodeID,
                    systemCodeName: e.systemCodeName
                  }


                  this.searchForm.policyclasslist.push(str)
                })

              } else if (mark == 3) {
                response.data.result.forEach(e => {

                  const str = {
                    systemCodeID: e.systemCodeID,
                    systemCodeName: e.systemCodeName
                  }


                  this.searchForm.policytypelist.push(str)
                })

              } else if (mark == 4) {
                response.data.result.forEach(e => {

                  const str = {
                    systemCodeID: e.systemCodeID,
                    systemCodeName: e.systemCodeName
                  }


                  this.searchForm.logoutReasonList.push(str)
                })

              } else if (mark == 6) {
                response.data.result.forEach(e => {

                  const str = {
                    systemCodeID: e.systemCodeID,
                    systemCodeName: e.systemCodeName
                  }


                  this.searchForm.pm_p4list.push(str)
                })
              } else {
                response.data.result.forEach(e => {

                  const str = {
                    systemCodeID: e.systemCodeID,
                    systemCodeName: e.systemCodeName
                  }


                  this.searchForm.pm_p5list.push(str)
                })
              }
            }

              break;

          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
    // 获取政策列表
    async getpolicycompilation(page, pagesize, pm_p1, policy_class_id, policy_type_id, pm_p4, start_create_time, end_create_time, start_logout_time, end_logout_time, logout_reason_id) {
      this.noticelist = []
      if (start_create_time === '') {
        start_create_time = 0
      }
      if (end_create_time === '') {
        end_create_time = 0
      }
      if (start_logout_time === '') {
        start_logout_time = 0
      }
      if (end_logout_time === '') {
        end_logout_time = 0
      }
      if (policy_class_id === '') {
        policy_class_id = -1
      }
      if (policy_type_id === '') {
        policy_type_id = -1
      }
      if (pm_p4 === '') {
        pm_p4 = -1
      }
      if (logout_reason_id === '') {
        logout_reason_id = -1
      }

      await queryPolicymeasureModel.querypolicymeasureinfolist(page, pagesize, pm_p1, policy_class_id, policy_type_id, pm_p4, start_create_time, end_create_time, start_logout_time, end_logout_time, logout_reason_id).then(response => {
        this.showDataLoading = false
        if (response.data.lsp !== null) {
          this.lsp = response.data.lsp
        }
        switch (response.data.code) {
          case 100:
            this.noticelist = response.data.result
            this.noticelist.forEach(e => {
              e.pmP10 = publicFun.timestampToTime(e.pmP10).substring(0, 10)
            })
            this.totalCount = response.data.recordcount
            break;
          case 101:
            break;
          case 102:
            this.$message.error(baseconfig.para_error_message);
            break;
          case 100002:
            this.$message.error(baseconfig.no_permission_message);
            break;
          default:
            this.$message.error(response.data.message);
            break;
        }
      }).catch(error => { })
    },
    // 搜索
    async onSearch() {
      console.log("rr")
      this.pageIndex = 1
      console.log(1111, this.searchForm.start_create_time, String(publicFun.timeToTimestamp(this.searchForm.start_create_time, 1)),)
      console.log(222, this.searchForm.end_create_time, String(publicFun.timeToTimestamp(this.searchForm.end_create_time, 2)))
      console.log(1111, this.searchForm.start_logout_time, String(publicFun.timeToTimestamp(this.searchForm.start_logout_time, 1)),)
      console.log(222, this.searchForm.end_logout_time, String(publicFun.timeToTimestamp(this.searchForm.end_logout_time, 2)))
      await this.getpolicycompilation(this.pageIndex, this.pageSize, this.searchForm.keywords, this.searchForm.policyclassid, this.searchForm.policytype, this.searchForm.pm_p4, String(publicFun.timeToTimestamp(this.searchForm.start_logout_time, 1)), String(publicFun.timeToTimestamp(this.searchForm.end_logout_time, 2)), String(publicFun.timeToTimestamp(this.searchForm.start_create_time, 1)), String(publicFun.timeToTimestamp(this.searchForm.end_create_time, 2)), this.searchForm.logout_reason_id)
    },
    //更改每页显示条数
    async handleSizeChange(val) {
      this.pageSize = val
      this.pageIndex = 1
      await this.getpolicycompilation(this.pageIndex, this.pageSize, this.searchForm.keywords, this.searchForm.policyclassid, this.searchForm.policytype, this.searchForm.pm_p4, String(publicFun.timeToTimestamp(this.searchForm.start_logout_time, 1)), String(publicFun.timeToTimestamp(this.searchForm.end_logout_time, 2)), String(publicFun.timeToTimestamp(this.searchForm.start_create_time, 1)), String(publicFun.timeToTimestamp(this.searchForm.end_create_time, 2)), this.searchForm.logout_reason_id)
    },
    //设置当前页
    async handleCurrentChange(val) {
      this.pageIndex = val
      await this.getpolicycompilation(this.pageIndex, this.pageSize, this.searchForm.keywords, this.searchForm.policyclassid, this.searchForm.policytype, this.searchForm.pm_p4, String(publicFun.timeToTimestamp(this.searchForm.start_logout_time, 1)), String(publicFun.timeToTimestamp(this.searchForm.end_logout_time, 2)), String(publicFun.timeToTimestamp(this.searchForm.start_create_time, 1)), String(publicFun.timeToTimestamp(this.searchForm.end_create_time, 2)), this.searchForm.logout_reason_id)
    },
    getDetail(row) {
      this.getpolicyDetail(row.policyMeasureID)

      this.dialogdetailVisible = true
    },
    async getpolicyDetail(policyMeasureID) {

      await policycompilationModule
        .policymeasureinfo(
          policyMeasureID,
          2
        ).then((res) => {
          switch (res.data.code) {
            case 100:
              {

                this.policyContent = res.data.result
                this.dialogdetailVisible = true


              }
              break;
            case 101:
              // this.$message.error(res.data.message)
              break;

            case 103:
              this.$message.error(res.data.message);
              break;
            case 100002:
              this.$message.error(baseconfig.no_permission_message);
              break;
            case 102:
              this.$message.error(res.data.message);
              break;
            default:
              this.$message.error(res.data.message);
              break;
          }
        }).catch((error) => { });
    },

  }
}
</script>
<style scoped>
.pageblock {
  text-align: right;
  margin-top: 5px;
}
.tab_val {
  /* padding: 20px; */
  margin-bottom: 0;
}
.demo-ruleForm {
  display: flex;
  flex-wrap: wrap;
}
.demo-ruleForm .el-form-item {
  min-width: 40%;
}

.tablecolumn {
  margin-left: 10px;
  margin-top: 5px;
}
.addorganization .el-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.pm_p1 {
  min-width: 100% !important;
  /* width: 100%; */
}
.addorganization >>> .el-dialog__body {
  width: 60%;
}
.addorganization >>> .el-input,
.addorganization >>> .el-select {
  width: 100%;
}
.addorganization >>> .el-form-item {
  min-width: 40%;
  /* width: 50%; */
}
@media only screen and (max-width: 1400px) {
  .addorganization {
    width: 92%;
  }
  .addorganization >>> .el-dialog__footer {
    width: 100%;
  }
}
@media only screen and (max-width: 1700px) {
  .addorganization >>> .el-form-item {
    min-width: 40%;
    width: 50%;
  }
}
.textarea,
.introducetype {
  min-width: 100% !important;
}
.introducetype .el-select {
  width: 31%;
}
.addorganization >>> .el-dialog__footer {
  width: 100% !important;
  margin-left: 25px;
  padding: 20px 0px;
  text-align: center;
}
.descriptionsheight >>> .is-bordered-label {
  width: 150px !important;
}
@media (max-width: 900px) {
  .descriptionsheight >>> .is-bordered-label {
    width: 125px !important;
  }
}
.fixedWidth1 {
  min-width: 860px !important;
}
.tipspan {
  color: red;
  line-height: 20px;
}
.tipintem >>> .el-form-item__content {
  line-height: inherit !important;
}
.demo-form-inline >>> .el-input__inner {
  height: 32px !important;
  line-height: 32px;
}
/* .hospitallevel >>>.el-form-item__content{
    display: flex;
    justify-content: space-between;
} */
</style>


